import { put, call, take, fork } from 'redux-saga/effects'
import { cardSettingCreateService } from '../../api/card'
//import { questionPatchSuccess } from '../../reducers/question/action'
import { cardSettingCreateSuccess } from '../../reducers/card/action'
import { CARD_SETTING_CREATE } from '../../reducers/card/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* cardSettingsCreateFlow(payload) {
  try {
    const { content, questionId, callback } = payload

    const response = yield call(cardSettingCreateService, content)
    yield put(cardSettingCreateSuccess(response.data, questionId))
    yield put(operationSuccess())

    if (content.key === 'badge') {
      window.badgeListNeedsRefresh = true
    }

    callback()
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* cardSettingsCreateWatcher() {
  while (true) {
    const action = yield take(CARD_SETTING_CREATE)
    const { payload } = action

    yield fork(generalSaga, cardSettingsCreateFlow, payload, false)
  }
}
